import type {
  ApiErrorBody,
  HttpErrorBody,
  HttpJsonError,
} from 'app/typings/error';
import { HttpError } from 'app/typings/error';

export function isApiError(error: unknown): error is ApiErrorBody {
  return (
    error !== null &&
    error !== undefined &&
    typeof error === 'object' &&
    'errorMessage' in error &&
    'errorCode' in error &&
    'source' in error !== undefined
  );
}

export function isHttpErrorBody(error: unknown): error is HttpErrorBody {
  return (
    error !== null &&
    error !== undefined &&
    typeof error === 'object' &&
    'message' in error &&
    'statusCode' in error
  );
}

export const isHttpApiError = (
  error: unknown
): error is HttpJsonError<ApiErrorBody> => {
  return (
    error instanceof HttpError &&
    typeof error.status === 'number' &&
    typeof error.message === 'string' &&
    'jsonObject' in error &&
    error.jsonObject !== null &&
    error.jsonObject !== undefined
  );
};

export const getErrorStatus = (error: unknown): number | undefined => {
  if (error instanceof HttpError) {
    return error.status;
  }

  if (
    error instanceof Error &&
    typeof error.cause === 'object' &&
    error.cause !== null
  ) {
    const { code } = error.cause as { code?: unknown };

    if (typeof code === 'number') {
      return code;
    }
  }

  return undefined;
};
